import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@services/_authentication.service';
import { RouteNavigationService } from '@services/_routeNavigation.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-tenant',
  templateUrl: './tenant.component.html',
  styleUrls: ['./tenant.component.css'],
})
export class TenantComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private routeNavService: RouteNavigationService
  ) {}

  ngOnInit() {
    this.getTenantInformation();
  }

  get returnUrl() {
    return this.route.snapshot.queryParams['returnUrl'] || null;
  }

  private getTenantInformation() {
    const subDomainName = this.route.snapshot.paramMap.get(
      'tenantSubDomainName'
    );
    this.authenticationService
      .authenticateTenant(subDomainName)
      .pipe(first())
      .subscribe(
        () => {
          // subdomain belongs to a tenant, so can proceed to login.
          // Interpolating the subDomainName in the url string so the tenants know they are on their system
          this.routeNavService.navigate('login', this.returnUrl);
        },
        () => {
          // No need to display an error here
          // an error here means the subdomain entered does not exist
          this.routeNavService.goToHome();
        }
      );
  }
}
